import React, { useEffect, useState } from "react";

const OtpResendTimer = ({
  duration = 60,         // seconds (default 1 minute)
  onResend = () => {},
  btnText = "Resend Code"   // callback when user clicks resend
}) => {
  const [timeLeft, setTimeLeft] = useState(duration);
  const [canResend, setCanResend] = useState(false);

  useEffect(() => {
    if (timeLeft <= 0) {
      setCanResend(true);
      return;
    }

    const timer = setInterval(() => {
      setTimeLeft((t) => t - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [timeLeft]);

  const handleResend = () => {
    onResend();
    setTimeLeft(duration); // restart countdown
    setCanResend(false);
  };

  const formatTime = (seconds) => {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${m}:${s < 10 ? `0${s}` : s}`;
  };

  return (
    <div className="flex flex-col items-center justify-center text-center mt-4">
      {canResend ? (
        <button
          onClick={handleResend}
          className="text-blue-600 text-sm font-medium hover:underline"
        >
         {btnText}
        </button>
      ) : (
        <>
          <p className="text-gray-500 text-sm mb-2">
            Resend code in{" "}
            <span className="font-semibold text-orange-600">
              {formatTime(timeLeft)}
            </span>
          </p>
          <button
            disabled
            className="text-blue-600 text-sm font-medium hover:underline cursor-not-allowed select-none disabled:text-gray-400"
          >
             {btnText}
          </button>
        </>
      )}
    </div>
  );
};

export default OtpResendTimer;
